var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_vm._m(0),_c('Login')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('img',{attrs:{"width":"64","height":"64","src":require("./assets/database-icon.png")}}),_vm._v("Data Manager")])
}]

export { render, staticRenderFns }